import React from 'react'
import CustomerCard from '../shared/CustomerCard'
import {Header} from '../shared'
import {deliveryTypes} from 'app/constant'
import {CustomerEmail, CustomerPhone, CustomerName} from 'app/components/customer/CustomerInfo'

interface Props {
  shippingAddress: any
  billingAddress: any
  paymentMethod: any
  email: string
  phone: number | any
  shippingPreferenceCompany: string
  orderDeliveryMethod: string
  firstName: string | null
  lastName: string | null
  id: string | null
  hasWineClub?: boolean
  paymentType?: string
  isDraftOrder?: boolean
  orderCustomer?: any
  giftMessage?: any
  customerName?: string
}

export const CustomerOrderView: React.FC<Props> = ({
  email,
  phone,
  shippingPreferenceCompany,
  orderCustomer,
  giftMessage,
  customerName,
  ...props
}) => {
  const orderEmail = getEmail(orderCustomer, email)

  if (!props.id && !(orderCustomer.name || orderCustomer.email)) {
    return (
      <div className='card shadow-lg rounded-10 mb-7'>
        <Header title='Guest' />
      </div>
    )
  }
  return (
    <CustomerCard
      {...props}
      orderCustomer={orderCustomer}
      customerName={customerName}
      giftMessage={giftMessage}
    >
      {(orderEmail || phone) && (
        <div className='mb-3'>
          <div className='fs-5 fw-bolder pb-3'>Contact Information</div>
          <div className='text-primary-active mb-2'>
            <CustomerEmail email={email} />
          </div>
          <span>
            <CustomerPhone phone={phone} />
          </span>
          {props.orderDeliveryMethod && props.orderDeliveryMethod === deliveryTypes.ship && (
            <>
              <div className='fs-5 fw-bolder pb-3 mt-4'>Shipping Preference Company</div>
              <div>{shippingPreferenceCompany ? shippingPreferenceCompany : '-'}</div>
            </>
          )}
        </div>
      )}
    </CustomerCard>
  )
}

export default CustomerOrderView

const getEmail = (orderCustomer: any, customerEmail: any) => {
  var email: any = ''
  if (orderCustomer && orderCustomer.email) {
    email = orderCustomer.email
  } else if (customerEmail) {
    email = customerEmail ?? null
  } else {
    email = null
  }
  return email
}
